import React from "react";
import { FaTimes } from 'react-icons/fa';
import { formatDateTime } from "../Constants/constant";
import { FaCheckCircle } from "react-icons/fa";

const NotificationPanel = ({show, onClose, handleClick, notifications, loading }) => {
  return (
    <>
      {/* Overlay */}
      {show && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={onClose}
        />
      )}

      {/* Slide-in Panel */}
      <div
        className={`fixed top-2 right-2 h-[97vh] w-[400px] bg-white shadow-lg border-l rounded-lg border-gray-200 z-50 transform transition-transform duration-400 ease-in-out ${
          show ? "translate-x-0" : "translate-x-[110%]"
        } overflow-hidden`}
      >
        {/* Header */}
        <div className="text-xl p-4 m-1 border-b flex justify-between items-center darkPurple font-semibold text-white rounded-lg">
        <h1 className="m-0 text-left">Notifications</h1>
         <button  onClick={onClose} className="shadow hoverRed bg-red-700 rounded-full w-fit z-[11] ">
            <FaTimes className=" text-white p-1 h-7 w-7" />
        </button>
        </div>

        {/* Notification List */}
        <ul className="overflow-y-auto max-h-[calc(100%-3rem)] divide-y divide-gray-300 text-left">
        {notifications.length > 0 ? (
            notifications.map((val) => (
            <li
                key={val.id}
                className={`flex items-start gap-3 px-4 py-3 transition-all duration-300 
                    ${loading || val?.message_status === 2 
                    ? "bg-gray-100 opacity-90" 
                    : "hover:bg-lime-100 cursor-pointer"} 
                    ${val?.message_status === 1 ? "bg-lime-50 font-bold text-muted" : "bg-white"}`}
                onClick={loading || val?.message_status === 2 ? undefined : () => handleClick(val)}
            >
            
                {/* Message */}
                <div className="flex-1">
                <p className={`text-sm text-gray-800 ${val?.message_status === 1 ? "font-bold" : "font-medium"}`}>
                    {val.message_text}
                </p>
                <p className="text-xs text-gray-500 mt-1">
                    {formatDateTime(val.created_date) || "Just now"}
                </p>
                </div>
            </li>
            ))
        ) : (
            <li className="px-4 py-6 text-center text-gray-500">
            🎉 You’re all caught up!
            </li>
        )}
        </ul>

      </div>
    </>
  );
};

export default NotificationPanel;
